module.exports = __webpack_public_path__ + "static/flow-acf3eb7e0e7b17e654bca82fc6345001.svg";